/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSlackDirectoryMemberSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetSlackDirectoryMemberRequest = {
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetSlackDirectoryMemberSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetSlackDirectoryMemberSecurity$outboundSchema: z.ZodMiniType<
  GetSlackDirectoryMemberSecurity$Outbound,
  GetSlackDirectoryMemberSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSlackDirectoryMemberSecurityToJSON(
  getSlackDirectoryMemberSecurity: GetSlackDirectoryMemberSecurity,
): string {
  return JSON.stringify(
    GetSlackDirectoryMemberSecurity$outboundSchema.parse(
      getSlackDirectoryMemberSecurity,
    ),
  );
}

/** @internal */
export type GetSlackDirectoryMemberRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetSlackDirectoryMemberRequest$outboundSchema: z.ZodMiniType<
  GetSlackDirectoryMemberRequest$Outbound,
  GetSlackDirectoryMemberRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getSlackDirectoryMemberRequestToJSON(
  getSlackDirectoryMemberRequest: GetSlackDirectoryMemberRequest,
): string {
  return JSON.stringify(
    GetSlackDirectoryMemberRequest$outboundSchema.parse(
      getSlackDirectoryMemberRequest,
    ),
  );
}
